import $ from 'jquery';
import * as cookieHelper from './cookieHelper';

export const init = () => {
	const $infoBar = $('.js-info-bar__wrap'),
		$closeBtn = $infoBar.find('.js-info-bar__close-btn'),
		hideInfoBarCookieName = $infoBar.data('cookie-name'),
		infoBarId = $infoBar.data('info-bar-id');

	function close() {
		$infoBar.hide();

		const hideInfoBarCookieObject = getHideInfoBarCookieObject(infoBarId, hideInfoBarCookieName);
		cookieHelper.setCookie(hideInfoBarCookieName, hideInfoBarCookieObject);

		function getHideInfoBarCookieObject(infoBarId, hideInfoBarCookieName) {
			let hideInfoBarCookieObject = {};
			const hideInfoBarRecord = {
				InfoBarId: infoBarId,
				DateTime: new Date().toISOString(),
			};

			try {
				hideInfoBarCookieObject = JSON.parse(cookieHelper.getCookie(hideInfoBarCookieName));

				const hideInfoBarRecordIdx = hideInfoBarCookieObject.Records.map((record) => record.InfoBarId).indexOf(infoBarId);

				if (hideInfoBarRecordIdx == -1) {
					hideInfoBarCookieObject.Records.push(hideInfoBarRecord);
				} else {
					hideInfoBarCookieObject.Records[hideInfoBarRecordIdx] = hideInfoBarRecord;
				}
			} catch (ex) {
				hideInfoBarCookieObject = {
					Records: [hideInfoBarRecord],
				};
			}

			return hideInfoBarCookieObject;
		}
	}

	$closeBtn.on('click', close);
};
